import Cookies from "js-cookie";


export function handleDayTypeClick(e, t, setService, setRecalcAvg) {
  if (e.target.innerHTML == t('compareperiods.all')) {
    setService("tous")
  } else if (e.target.innerHTML == t('compareperiods.week')) {
    setService("se")
  } else {
    setService("fds")
  }
  setRecalcAvg ? setRecalcAvg(true) : '';
}


export function handlePeriodClick(e, t, setPeriod, setRecalcAvg) {
  if (e.target.innerHTML == t('compareperiods.all')) {
    setPeriod("all")
  } else if (e.target.innerHTML == t('compareperiods.morning')) {
    setPeriod("morning")
  } else if (e.target.innerHTML == t('compareperiods.am')) {
    setPeriod("am")
  } else if (e.target.innerHTML == t('compareperiods.offpeak')) {
    setPeriod("op")
  } else if (e.target.innerHTML == t('compareperiods.pm')) {
    setPeriod("pm")
  } else {
    setPeriod("evening")
  }

  setRecalcAvg ? setRecalcAvg(true) : '';
}


export function handleMultiPeriodClick(e, t, period, setPeriod, buttonId) {

  let updatedPeriod = [...period]; // Create a new array to avoid mutations

  if (buttonId === 'all') {
    updatedPeriod = ['all']; // Set to 'all' directly
  } else {
    const index = updatedPeriod.indexOf(buttonId);
    if (index !== -1) {
      updatedPeriod.splice(index, 1); // Remove if already exists
    } else {
      if (buttonId !== 'all') {
        const allIndex = updatedPeriod.indexOf('all');
        if (allIndex !== -1) {
          updatedPeriod.splice(allIndex, 1); // Remove 'all' if other period is added
        }
      }
      updatedPeriod.push(buttonId); // Add the clicked period
    }
  }

  setPeriod(updatedPeriod); // Update the state with the new period array

}


export function handleRouteClick(e, t, setSelectedRoute) {
  if (e.target.value !== t('trends.routes')) {
    setSelectedRoute(e.target ? e.target.value : e);
  } else {
    setSelectedRoute('all');
  }
}


export function handleMultiRoutes(e, selectedRoutes, setSelectedRoutes, setRecalcAvg) {

  const currentIndex = selectedRoutes.indexOf(e);
  const newSelectedOptions = [...selectedRoutes];

  if (newSelectedOptions.find((e) => e == 'all') == 'all') {
    const allIndex = newSelectedOptions.indexOf('all');
    newSelectedOptions.splice(allIndex, 1);
  }

  if (currentIndex === -1) {
    newSelectedOptions.push(e);
  } else {
    newSelectedOptions.splice(currentIndex, 1);
  }

  setSelectedRoutes(newSelectedOptions);
  setRecalcAvg(true);

}


//checkFilterCookies
export function checkFilterCookies() {

  let serviceFilter = Cookies.get("service") ? Cookies.get("service") : '';

  let periodParse = Cookies.get("period") ? JSON.parse(Cookies.get("period")) : '';
  let routeParse = Cookies.get("route") ? JSON.parse(Cookies.get("route")) : '';

  
  // var json_str = getCookie('mycookie');
  // var arr = JSON.parse(json_str);
  let cookiesObj = {};

  if (serviceFilter !== '') {
    cookiesObj.service = serviceFilter;
  }
  if (periodParse !== '') {
    cookiesObj.period = JSON.parse(periodParse)
  }
  if (routeParse !== '') {
    cookiesObj.route = JSON.parse(routeParse)
  }

  return [cookiesObj]
}


//updateFilterCookies
export function updateFilterCookies(service, period, selectedRoute) {

  let arrayP = JSON.stringify(period);

  let arrayR = selectedRoute ? JSON.stringify(selectedRoute) : '';

  Cookies.set("service", service, { expires: 1 });
  Cookies.set("period", JSON.stringify(arrayP), { expires: 1 });

  if (arrayR !== '') {
    Cookies.set("route", JSON.stringify(arrayR), { expires: 1 });
  }
};


//deleteFilterCookies
export function deleteFilterCookies() {
  Cookies.remove("service");
  Cookies.remove("period");
  Cookies.remove("route");
}

function translateFilter() {

}